import { createAction, createReducer } from '@reduxjs/toolkit';

export const playMainTheme = createAction('sound/playMainTheme');
export const pauseMainTheme = createAction('sound/pauseMainTheme');
export const playTransmission01 = createAction('sound/playTransmission01');
export const pauseTransmission01 = createAction('sound/pauseTransmission01');

type SoundState = {
  soundPlaying?: string;
};

const initialState = { soundPlaying: undefined } as SoundState;

const soundReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(playMainTheme, (state, action) => {
      state.soundPlaying = 'mainTheme';
    })
    .addCase(pauseMainTheme, (state, action) => {
      state.soundPlaying = undefined;
    })
    .addCase(playTransmission01, (state, action) => {
      state.soundPlaying = 'transmission01';
    })
    .addCase(pauseTransmission01, (state, action) => {
      state.soundPlaying = undefined;
    });
});

export default soundReducer;
